/* This file is autogenerated, see readme.md for instructions */
import ConditionSvgIcon from '@bloomreach/banana-theme/icons/condition.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ConditionIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ConditionSvgIcon />
    </Icon>
  );
});

ConditionIcon.displayName = 'ConditionIcon';

export default ConditionIcon;
